import EventEmitter from 'events';
import axios from 'axios';
import Symbol from 'es6-symbol/polyfill';

let singleton = Symbol();
let singletonEnforcer = Symbol();

class SocieteApiService extends EventEmitter {
  //________________________________________________________ constructor
  // -
  constructor(pEnforcer) {
    if (pEnforcer !== singletonEnforcer) {
      throw 'Cannot construct singleton';
    }
    super();
    this._instance = axios.create();
    this._cancelToken = axios.CancelToken;
  }

  static getInstance() {
    if (!this[singleton]) {
      this[singleton] = new SocieteApiService(singletonEnforcer);
    }
    return this[singleton];
  }

  async findCompanies( name, dep ) {
    if(this.cancelCompanies) this.cancelCompanies();
    const response = await this._instance({
      method: 'GET',
      url: window.Routing.generate('app_api_search_companies'),
      params: {
        nom: name.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
        dep
      },
      cancelToken: new this._cancelToken( (c) => {
        this.cancelCompanies = c;
      })
    })
    return response.data.data.results;
  }

  async findEstablishments( name, dep ) {
    if(this.cancelEstablishments) this.cancelEstablishments();
    const response = await this._instance({
      method: 'GET',
      url: window.Routing.generate('app_api_search_establishments'),
      params: {
        nom: name.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
        dep
      },
      cancelToken: new this._cancelToken( (c) => {
        this.cancelEstablishments = c;
      })
    })
    return response.data.data.results;
  }

  async company( siren ) {
    const response = await this._instance({
      method: 'GET',
      url: window.Routing.generate('app_api_get_companies_legal_infos', {id: siren})
    })
    return response.data.infolegales;
  }

  async establishments( siren ) {
    const response = await this._instance({
      method: 'GET',
      url: window.Routing.generate('app_api_get_companies_establishments', {id: siren})
    })
    return response.data.data.etablissements;
  }
}
export default SocieteApiService.getInstance();
